require('./emailNotificationBrowser.i18n.json');
require('./emailNotificationBrowser.tpl.html');
require('./emailNotificationRepository.js');
require('./emailStateModel.js');

/*@ngInject*/
const EmailNotificationBrowserController = function ($rootScope, $scope, $timeout, $state, localization, coreConstant, configurationMediator, notificationPreferencesType, notificationPreferencesAction, modalUtil, navigationStateModel, configurationActionsUtil, databaseDownloadSectionName, emailStateModel) {

    localization.getTranslationByKey('emailNotificationBrowser').then(function (translations) {

        $scope.viewModel = {
            totalEmailNotifications: 0,
            recordCountText: _.get(translations, 'recordCountText'),
            recordsCountText: _.get(translations, 'recordsCountText'),
            isGridEmpty: true,
            totalEmailNotification: 0,
            requestParams: {
                key: 'name',
                startIndex: 0,
                pageSize: 25,
                sortType: 'asc',
                searchString: ''
            },
            searchPrompt: _.get(translations, 'searchPrompt'),
            shortDateTimeFormat: 'MM/dd/yy hh:mma'
        };

        $scope.actions = [];
        $scope.context = {
            identifier: 'emailNotificationBrowser',
            actions: {},
            fallthrough: null,
            model: {
                contextType: coreConstant.CONTEXT_NONE
            }
        };
        $scope.context.actions[coreConstant.CONTEXT_NONE] = '';

        function loadActions() {
            configurationMediator.loadEmailNotificationActions().then(function (actions) {
                const allActions = [];
                allActions.push({
                    actions: actions.actions,
                    contextType: $scope.context.model.contextType
                });
                $scope.actions = allActions;

                $scope.actionsTimeLastModified = new Date().getTime();
            });
        };

        function loadEmails() {
            $scope.viewModel.isLoading = true;
            configurationMediator.loadEmailNotification($scope.viewModel.requestParams).then(function (emailNotifications) {
                $scope.viewModel.emailNotifications = emailNotifications.records;
                $scope.viewModel.totalEmailNotification = emailNotifications.totalRecords;
                $scope.viewModel.isGridEmpty = $scope.viewModel.emailNotifications.length === 0;

                $timeout(function () {
                    $rootScope.$broadcast(coreConstant.event.RECALCULATE_GRID_PAGING);
                    $scope.viewModel.isLoading = false;
                }, 0);
            });
            emailStateModel.saveViewState('configuration.emailBrowser', null);
            navigationStateModel.saveViewState('configuration.emailBrowser', null);
        }

        function checkPreviousViewState() {
            emailStateModel.restoreViewState($state.name, $scope.viewModel);
                    loadEmails();
            }

        $scope.onPagingChange = function ($event, params) {
            $scope.viewModel.requestParams.startIndex = params.startIndex;
            emailStateModel.saveViewState('configuration.emailBrowser', null);
            loadEmails();
        };

        $scope.onSortChange = function (event, params) {
            $scope.viewModel.requestParams.key = params.key;
            $scope.viewModel.requestParams.sortType = params.sortType;
            emailStateModel.saveViewState('configuration.emailBrowser', null);
            loadEmails();
        };

        $scope.getStatus = function (item) {
            return (item.enabled) ? _.get(translations, 'status.active') : _.get(translations, 'status.inactive');
        };

        $scope.onSearchInputChange = _.debounce(function () {
            $scope.viewModel.requestParams.startIndex = 0;
            $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
            loadEmails();
        }, 200);

        $scope.onClearSearchTerm = function () {
            $scope.viewModel.requestParams.searchString = '';
            $scope.viewModel.requestParams.startIndex = 0;
            $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
            loadEmails();
        };

        $scope.handleAction = function (action, file) {
            if (action.enabled) {
                switch (action.name) {
                    case notificationPreferencesAction.NEW_EMAIL:
                        $state.go('configuration.manageEmail');
                        break;
                    case notificationPreferencesAction.BACKUP:
                        configurationActionsUtil.backup(databaseDownloadSectionName.NOTIFICATION_EMAIL_TEMPLATES, _.get(translations, 'backup.name'), _.get(translations, 'backup.loadingBar'), _.get(translations, 'backup.successMessage'));
                        break;
                    default:
                        modalUtil.showActionNotImplementedModal(action.name);
                        break;
                }
            }
        };

        $scope.onClickRow = function (event, item) {
            const navigationModel = {
                parentState: 'configuration.emailBrowser',
                currentState: 'configuration.manageEmail',
                data: {
                    templateId: item.id
                }

            };
            $state.go('configuration.manageEmail', {
                templateId: item.id
            });
            emailStateModel.saveViewState(navigationModel.parentState, $scope.viewModel);
            navigationStateModel.saveViewState(navigationModel.parentState, navigationModel);
        };

        $scope.$on('$destroy', function () {
            emailStateModel.saveViewState($state.name, $scope.viewModel);
        });

        loadActions();
        checkPreviousViewState();
    });

    $scope.$on(ux.datagrid.events.ON_STARTUP_COMPLETE, function () {
        $scope.$apply();
    });
};

angular.module('ums.configuration')
    .controller('emailNotificationBrowserController', EmailNotificationBrowserController);
